import _ from "lodash"
import { forwardRef  } from "react"
import { createSearchParams, Link as RouterLink, useSearchParams, NavLink as RouterNavLink, parsePath } from "react-router-dom"

import type { Path, LinkProps as RouterLinkProps, NavLinkProps as RouterNavLinkProps, To } from "react-router-dom"

type LinkProps = RouterLinkProps & {to: To | number}

export const Link = forwardRef<HTMLAnchorElement, LinkProps>(function Link(props: LinkProps, ref) {
  const update = useUpdateSearchParams()
  // @ts-ignore // to can be a negative number
  const to = typeof props.to === 'number' ? props.to : update(props.to)
  return <RouterLink {...{ ...props, to }} ref={ref} />
})

export function NavLink(props: RouterNavLinkProps) {
    const update = useUpdateSearchParams()
    // console.log(to)
    // @ts-ignore // to can be a negative number
    const to = typeof props.to === 'number' ? props.to : update(props.to)
    return <RouterNavLink {...{...props, to}} />
}

export function useUpdateSearchParams() {
    const [searchParams] = useSearchParams()

    return (to: To) => {
      return updateSearchParams(searchParams, to)
    }
}

export function updateSearchParams(searchParams: URLSearchParams, to: To) {

    if (to === undefined) return to

    const current: Partial<Path> = typeof to === 'string' ? parsePath(to) : to
    const currentSearch = createSearchParams(current.search)

    const relevant = [
        ...[...currentSearch.entries()].filter(([name]) => name !== 'filter' && name !== 'activeOnly'),
        ['states', searchParams.get('states')],
        ['filter', searchParams.get('filter')],
        // ['activeOnly',  searchParams.get('activeOnly')],
    ].filter(([key, value]) => !_.isNil(value)) as ([string, string][])

    // console.log({current, cs: [...currentSearch.entries()], cso: Object.fromEntries(currentSearch.entries())})
    //console.log({f: relevant.filter(([name]) => name === 'filter').map(([_, q]) => decode(q))})

    const queryParams = createSearchParams(relevant).toString()

    return {...current, search: queryParams} as Partial<Path>
}